"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ActionTypes = require("pricing-pages-unified-ui/constants/ActionTypes");

var MerchandiseIdsTreatedAsOwned = function MerchandiseIdsTreatedAsOwned() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  var _ref = arguments.length > 1 ? arguments[1] : undefined,
      type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case _ActionTypes.MERCHANDISE_IDS_TREATED_AS_OWNED_RECEIVED:
      return payload;

    default:
      return state;
  }
};

var _default = MerchandiseIdsTreatedAsOwned;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/reducers/MerchandiseIdsTreatedAsOwned.js
// module id = 539
// module chunks = 5 6